var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('VMenu', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "distance": 12,
      "instantMove": true,
      "themes": {
        menu: {
          delay: {
            hide: 0
          }
        }
      }
    },
    on: {
      "show": function show($event) {
        return _vm.$emit('show');
      }
    },
    scopedSlots: _vm._u([{
      key: "popper",
      fn: function fn() {
        return [_vm._t("content")];
      },
      proxy: true
    }], null, true)
  }, [[_vm._t("toggler")]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }